<template>
  <v-carousel v-model="currentSlide" :hide-delimiters="!delimiters" :show-arrows="showArrows" :cycle="cycle" style="max-width:calc(100% - 24px)">
    <v-carousel-item v-for="(item, index) in items" :key="'item-' + index" :src="item.backgroundImage ? item.image : ''" :contain="item.contain">
      <slot name="default"></slot>
      <v-sheet :color="item.backgroundImage ? 'transparent' : item.backgroundColor" height="100%">
        <v-row class="fill-height" :align="item.align" :justify="item.justify">
          <div v-html="parseText(item.text)" :style="style(item)" class="carousel-overlay-text"></div>
        </v-row>
      </v-sheet>
    </v-carousel-item>
  </v-carousel>
</template>
<style>
div.carousel-overlay-text {
  padding: .7em;
  font-size: 1.5rem !important;
}
div.carousel-overlay-text :last-child {
  margin-bottom: 0
}
</style>
<script>
import { watch, onBeforeUnmount, onMounted, ref } from '@vue/composition-api'
export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  setup (props, { root, emit }) {
    const items = ref([])
    const cycle = ref(true)
    const showArrows = ref(true)
    const delimiters = ref(true)
    const mustComplete = ref(false)

    const onPatchedListener = (data) => { if (data._id === props.id) loadBlock() }
    onMounted(() => { root.$feathers.service('orientation/block').on('patched', onPatchedListener) })
    onBeforeUnmount(() => { root.$feathers.service('orientation/block').removeListener('patched', onPatchedListener) })

    function loadBlock () {
      root.$feathers.service('orientation/block').get(props.id).then((data) => {
        cycle.value = data.cycle
        showArrows.value = data.showArrows
        delimiters.value = data.delimiters
        mustComplete.value = data.mustComplete || false
        items.value = data.items

        if (!data.mustComplete) {
          emit('activeFinish')
        } else {
          emit('activeWaiting')
        }
      })
    }
    loadBlock()

    function colorOpacity (color, opacity) {
      if (opacity > 100) opacity = 100
      switch (color) {
        case 'white':
          return 'rgba(255, 255, 255, ' + (opacity / 100) + ')'
        case 'black':
          return 'rgba(0, 0, 0, ' + (opacity / 100) + ')'
        case 'blue':
          return 'rgba(0, 0, 255, ' + (opacity / 100) + ')'
        case 'green':
          return 'rgba(0, 255, 0, ' + (opacity / 100) + ')'
        case 'red':
          return 'rgba(255, 0, 0, ' + (opacity / 100) + ')'
      }
      return 'transparent'
    }

    const currentSlide = ref(0)
    watch(currentSlide, () => {
      if (mustComplete.value && currentSlide.value === items.value.length - 1) {
        emit('activeFinish')
      }
    })

    function parseText (text) {
      return text.replace(/<a /ig, '<a target="_blank"')
    }

    function style (item) {
      let style = []
      style.push('color:' + colorOpacity(item.textColor, item.opacity + 10))
      style.push((item.backgroundImage ? 'background-color:' + colorOpacity(item.backgroundColor, item.opacity) + ';' : ''))
      style.push('text-align:' + (item.justify === 'start' ? 'left' : (item.justify === 'end' ? 'right' : 'center')))
      let margin = 'margin:0 ' + (showArrows.value ? '12px' : '60px')
      if (delimiters.value) margin += ' 40px'
      style.push(margin)
      return style.join(';')
    }

    return {
      items,
      cycle,
      showArrows,
      delimiters,
      colorOpacity,
      currentSlide,
      parseText,
      style
    }
  }
}
</script>
